import "./NavbarStyles.css";

import React, { useState } from 'react';
import { Link } from "react-router-dom";

import { NavLink } from "react-router-dom";

import { FaBars, FaTimes } from "react-icons/fa";

import logo from "../assets/logo.png";

const Navbar = () => {

    const [click, setClick] = useState(false);
    const handleClick = () => setClick(!click);

    const [color, setColor] = useState(false);
    const changeColor = () => {
        if(window.scrollY >=100){
            setColor(true);
        }else{
            setColor(false);
        }
    };

    window.addEventListener("scroll", changeColor);


  return (
    <div className={color ? "header header-bg" : "header"}>
        <Link to="/">
            {/*<h1>Arturo<span style={{color:"green"}}>Code</span></h1>*/}
            <img src={logo} alt="Logo de ArturoCode" style={{width:"60%"}} />
        </Link>
        <ul 
        className={click ? "nav-menu active" : "nav-menu"}>
            <li>
                <Link to="/">Inicio</Link>
            </li>
            <li>
                <Link to="/sobre-mi">Sobre mí</Link>
            </li>
            <li>
                <NavLink to="https://arturocodeblog.super.site/" target={"_blank"}>Blog</NavLink>
            </li>
            <li>
                <Link to="/proyectos">Proyectos</Link>
            </li>
            <li>
                <NavLink to="https://arturocodeblog.super.site/recursos" target={"_blank"}>Recursos</NavLink>
            </li>
            <li>
                <NavLink to="https://arturocode.gumroad.com/" target={"_blank"}>Tienda</NavLink>
            </li>
            <li>
                <Link to="/contacto">Contacto</Link>
            </li>
        </ul>
        <div className="hamburger" onClick={handleClick}>
            {click ? (
                <FaTimes size={30} style={{color: "#fff"}} />
            ) : ( 
                <FaBars size={30} style={{color: "#fff"}} />
            )}
        </div>
    </div>
  )
}

export default Navbar